import { Directive } from '@angular/core';
import { FlexOrderDirective } from '@angular/flex-layout';

const selector = `[fxFlexOrder.handset.landscape]`;
const inputs = ['fxFlexOrder.handset.landscape'];

@Directive({
  selector, 
  inputs
})
export class CustomFxFlexOrderHandsetLandscapeDirective extends FlexOrderDirective {
  protected inputs = inputs;
}
